import Splide from "@splidejs/splide";

export class SliderManager {
    constructor() {
        if (document.querySelector('.team-slider')) {
            this.initializeTeamSlider();
        }

        if (document.querySelector('.testimonial-slider')) {
            this.initializeTestimonialSlider();
        }

        if (document.querySelector('.full-slider')) {
            this.initializeFullSlider();
        }

        if (document.querySelector('.process-block')) {
            this.initializeProcessBlock();
        }

        if (document.querySelector('.charities-block')) {
            this.initializeLogosSlider();
        }
    }

    initializeTeamSlider() {
        const teamList = document.querySelector('.splide__list.team-list');
        const dataStyle = teamList.removeAttribute('data-style');

        new Splide('.team-slider', {
            perPage: 1,
            type: 'loop',
            arrows: false,
            mediaQuery: 'min',
            breakpoints: {
                640: {
                    perPage: 2,
                    gap: '20px',
                },
                1024: {
                    destroy: true,
                },
            },
        }).mount();
    }

    initializeTestimonialSlider() {
        new Splide('.testimonial-slider', {
            perPage: 1,
            type: 'loop',
            autoplay: true,
            arrows: false,
            mediaQuery: 'min',
            breakpoints: {
                1400: {
                    arrows: true,
                },
            },
        }).mount();
    }

    initializeFullSlider() {
        document.querySelectorAll('.full-slider').forEach(item => {
            let destroy_mobile = item.classList.contains('slider-no-sp')
            new Splide(item, {
                type: 'slide',
                gap: '2rem',
                rewind: true,
                padding: {left: 0, right: 0},
                breakpoints: {
                    1024: {
                        gap: '12px',
                        arrows: false,
                        padding: {left: 0, right: '5%'},
                    },
                    768 : {
                      destroy: destroy_mobile
                    }
                },
            }).mount();
        })
    }

    initializeProcessBlock() {
        const processMainSlider = new Splide('.process-image-slider', {
            type: 'loop',
            perPage: 1,
            arrows: false,
            pagination: false,
            gap: 0,
            padding: 0,
        });

        const processContentSlider = new Splide('.process-content-slider', {
            type: 'slide',
            perPage: 1,
            arrows: false,
            pagination: true,
            mediaQuery: 'min',
            breakpoints: {
                640: {
                    perPage: 2,
                    gap: '20px',
                },
                1024: {
                    destroy: true,
                },
            },
        });

        let current;
        const processItems = document.querySelectorAll('.process-item');
        processItems.forEach((item, index) => {
            item.addEventListener('click', () => {
                processMainSlider.go(index);
            });
        });

        setTimeout(() => {
            processItems[0].classList.add('is-active');
        }, 500);

        processMainSlider.on('mounted move', () => {
            let processItem = processItems[processMainSlider.index];
            if (processItem) {
                if (current) {
                    current.classList.remove('is-active');
                }

                processItem.classList.add('is-active');
                current = processItem;
            }
        });

        processMainSlider.sync(processContentSlider);
        processMainSlider.mount();
        processContentSlider.mount();
    }

    initializeLogosSlider() {
        new Splide('.logos-slider', {
            perPage: 4,
            perMove: 1,
            type: 'loop',
            autoplay: true,
            arrows: false,
            mediaQuery: 'max',
            breakpoints: {
                768: {
                    perPage: 3,
                },
                600: {
                    perPage: 2,
                },
                480: {
                    perPage: 1,
                }
            },
        }).mount();
    }
}
